var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAprendiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aprendiz",
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8144",
    "data-name": "Grupo 8144",
    transform: "translate(-802.922 -499.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6188",
    "data-name": "Grupo 6188",
    transform: "translate(749 460)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_771",
    "data-name": "Trazado 771",
    d: "M92.627,231.443a10.055,10.055,0,0,0-.949,14.357,118.7,118.7,0,0,0,175.485,1.762,10.015,10.015,0,0,0-1.278-14.731l-85.447-65.813a10.033,10.033,0,0,0-12.632.315Z",
    fill: "#655dc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_772",
    "data-name": "Trazado 772",
    d: "M167.806,167.333,94.1,230.184c22.317,23.663,54.12,40.076,89.081,39.205,31.974-.8,60.671-16.231,81.5-37.485l-84.243-64.886A10.033,10.033,0,0,0,167.806,167.333Z",
    transform: "translate(749 460)",
    fill: "#524ba4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_203",
    "data-name": "Elipse 203",
    cx: 99.071,
    cy: 99.071,
    r: 99.071,
    transform: "translate(828.121 516.482)",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_204",
    "data-name": "Elipse 204",
    cx: 89.464,
    cy: 89.464,
    r: 89.464,
    transform: "translate(837.729 526.09)",
    fill: "#fc9a05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6191",
    "data-name": "Grupo 6191",
    transform: "translate(749 460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_205",
    "data-name": "Elipse 205",
    cx: 80.801,
    cy: 80.801,
    r: 80.801,
    transform: "translate(63.922 155.554) rotate(-45)",
    fill: "#02daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_788",
    "data-name": "Trazado 788",
    d: "M178.231,237.856c-1.017,0-2.03-.019-3.054-.056a82.281,82.281,0,1,1,3.054.056Zm-.11-161.605a79.348,79.348,0,1,0,2.977.055Q179.607,76.25,178.121,76.251Z",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6213",
    "data-name": "Grupo 6213",
    transform: "translate(804.131 373.282) rotate(20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6210",
    "data-name": "Grupo 6210"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_222",
    "data-name": "Elipse 222",
    cx: 2.468,
    cy: 2.468,
    r: 2.468,
    transform: "translate(228.93 150.859)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6211",
    "data-name": "Grupo 6211"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_223",
    "data-name": "Elipse 223",
    cx: 1.943,
    cy: 1.943,
    r: 1.943,
    transform: "translate(238.046 143.029)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6212",
    "data-name": "Grupo 6212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_858",
    "data-name": "Trazado 858",
    d: "M234.88,136.293a1.2,1.2,0,1,1-1.587.62A1.2,1.2,0,0,1,234.88,136.293Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7303",
    "data-name": "Grupo 7303",
    transform: "translate(-339.695 -12.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7247",
    "data-name": "Grupo 7247",
    transform: "translate(1234.049 605.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_478",
    "data-name": "Rect\\xE1ngulo 478",
    width: 65.678,
    height: 62.667,
    rx: 31.333,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7248",
    "data-name": "Grupo 7248",
    transform: "translate(1231.882 603.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2441",
    "data-name": "Trazado 2441",
    d: "M1496.217,1681.208a10.248,10.248,0,0,1,10.248,10.248v42.17a10.248,10.248,0,0,1-10.248,10.248h-45.182a10.248,10.248,0,0,1-10.248-10.248v-42.17a10.248,10.248,0,0,1,10.248-10.248h45.182m0-2.167h-45.182a12.429,12.429,0,0,0-12.415,12.416v42.17a12.429,12.429,0,0,0,12.415,12.416h45.182a12.43,12.43,0,0,0,12.416-12.416v-42.17a12.43,12.43,0,0,0-12.416-12.416Z",
    transform: "translate(-1438.62 -1679.041)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7249",
    "data-name": "Grupo 7249",
    transform: "translate(1241.488 698.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2442",
    "data-name": "Trazado 2442",
    d: "M1608.266,3210.448a1.078,1.078,0,0,1-.575-.166c-5.531-3.474-13.649-1.938-13.73-1.922a1.084,1.084,0,0,1-.419-2.126c.365-.073,9.033-1.724,15.3,2.213a1.084,1.084,0,0,1-.577,2Z",
    transform: "translate(-1592.668 -3205.828)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7250",
    "data-name": "Grupo 7250",
    transform: "translate(1234.495 596.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2443",
    "data-name": "Trazado 2443",
    d: "M1544.869,1681.758c-.016.165.368,6.594-16.791,5.952-7.274-.274-12.221-1.666-13.993-5.494-1.585-3.427-1.357-16.843-1.357-16.843V1643.8h-.024v21.576s.084,4.958-.206,9.615c-.187,3-.531,5.884-1.151,7.228-1.772,3.828-5.909,5.22-13.183,5.494-17.16.642-17.585-5.787-17.6-5.952a5.993,5.993,0,0,1,.26-2.468c1.447-4.454,7.783-6.54,7.783-6.54a227.738,227.738,0,0,1-5.429-28.422c-.436-4.1-.653-8.257-.7-12.389-.179-17,2.6-33.7,5.226-45.59.8-3.628,1.593-6.808,2.278-9.409,1.284-4.863,2.213-7.713,2.213-7.713h41.036s.978,3,2.316,8.1c.672,2.557,1.43,5.643,2.205,9.141,2.62,11.885,5.378,28.547,5.2,45.5-.043,4.121-.263,8.26-.7,12.356a227.175,227.175,0,0,1-5.429,28.422S1545.49,1675.6,1544.869,1681.758Z",
    transform: "translate(-1480.53 -1569.227)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7251",
    "data-name": "Grupo 7251",
    transform: "translate(1234.495 666.082)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2444",
    "data-name": "Trazado 2444",
    d: "M1544.867,2730.567c-.016.166-.442,6.594-17.6,5.952-7.274-.274-11.411-1.667-13.183-5.494-.621-1.344-.964-4.223-1.151-7.228l-.16-9.688-.274,9.688c-.187,3-.531,5.885-1.151,7.228-1.772,3.828-5.909,5.221-13.183,5.494-17.16.642-17.585-5.787-17.6-5.952a5.99,5.99,0,0,1,.26-2.468c.62,1.021,2.474,2.492,7.913,3.24,8.829,1.211,18.311.133,19.921-5.738,1.211-4.419,3.2-26.327-3.506-29.194-10.376-4.435-14.185-8-11.3-8.575,1.466-.292,5.329.924,18.864.924s17.4-1.216,18.864-.924c2.885.574-.924,4.14-11.3,8.575-6.71,2.866-4.717,24.775-3.506,29.194,1.609,5.871,11.091,6.949,19.921,5.738,5.44-.748,7.293-2.219,7.913-3.24A5.992,5.992,0,0,1,1544.867,2730.567Z",
    transform: "translate(-1480.53 -2687.788)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7252",
    "data-name": "Grupo 7252",
    transform: "translate(1233.41 613.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2445",
    "data-name": "Trazado 2445",
    d: "M1514.1,1941.625q-1.155,0-2.391-.046c-5.734-.215-12.614-1.1-14.934-6.12a7.237,7.237,0,0,1-.386-1.1,7.133,7.133,0,0,1-.386,1.1c-1.869,4.041-5.961,5.814-14.125,6.12-17.194.647-18.611-5.666-18.721-6.937-.573-5.678,5.437-8.771,7.834-9.772a225.608,225.608,0,0,1-5.219-27.64c-1.749-16.442-.279-35.266,4.5-57.547a1.084,1.084,0,0,1,2.119.454c-4.726,22.053-6.185,40.653-4.46,56.864a227.966,227.966,0,0,0,5.4,28.261l.26.986-.968.319c-.077.026-7.831,2.662-7.306,7.869.007.076.669,5.572,16.482,4.979,7.221-.271,10.767-1.68,12.24-4.865.976-2.109,1.236-9.019,1.269-13.559,0-.72,0-1.345,0-1.834,0-.362-.006-.69-.011-.979V1895.5h2.167l.023,1.083v21.576c0,.294-.009.629-.011,1,0,.486.005,1.11,0,1.83.033,4.549.294,11.454,1.269,13.562,1.424,3.08,5.448,4.58,13.048,4.865,9.224.345,13.034-1.362,14.607-2.856a2.938,2.938,0,0,0,1.061-2l.005-.111c.526-5.216-7.227-7.852-7.306-7.878l-.966-.32.258-.984a228.017,228.017,0,0,0,5.4-28.261c1.693-15.912.308-34.16-4.232-55.787a1.084,1.084,0,1,1,2.121-.445c4.588,21.853,5.984,40.321,4.266,56.462a225.6,225.6,0,0,1-5.219,27.64c2.392,1,8.378,4.08,7.838,9.74a5.079,5.079,0,0,1-1.734,3.519C1525.444,1940.452,1520.81,1941.625,1514.1,1941.625Z",
    transform: "translate(-1463.117 -1838.825)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7253",
    "data-name": "Grupo 7253",
    transform: "translate(1276.275 698.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2446",
    "data-name": "Trazado 2446",
    d: "M2164.831,3212.393c-.531-.141-1.146-.269-1.734-.365s-1.2-.184-1.8-.248a26.746,26.746,0,0,0-3.649-.127,20.321,20.321,0,0,0-3.639.473,15.52,15.52,0,0,0-3.483,1.272,15.852,15.852,0,0,1,3.322-1.791,21.188,21.188,0,0,1,3.678-1.031,28.055,28.055,0,0,1,3.82-.421c.642-.026,1.286-.034,1.932-.016s1.277.048,1.973.127a1.087,1.087,0,1,1-.245,2.161,1.062,1.062,0,0,1-.149-.028Z",
    transform: "translate(-2150.525 -3210.13)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7254",
    "data-name": "Grupo 7254",
    transform: "translate(1241.525 698.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2447",
    "data-name": "Trazado 2447",
    d: "M1594.224,3210.266c.7-.079,1.319-.112,1.973-.127s1.29-.01,1.933.016a28.06,28.06,0,0,1,3.82.421,21.172,21.172,0,0,1,3.678,1.031,15.85,15.85,0,0,1,3.322,1.791,15.525,15.525,0,0,0-3.483-1.272,20.328,20.328,0,0,0-3.64-.473,26.743,26.743,0,0,0-3.649.127c-.6.064-1.206.144-1.8.248s-1.2.225-1.734.365l-.02,0a1.087,1.087,0,0,1-.556-2.1A1.168,1.168,0,0,1,1594.224,3210.266Z",
    transform: "translate(-1593.259 -3210.13)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7270",
    "data-name": "Grupo 7270",
    transform: "translate(1233.319 636.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7255",
    "data-name": "Grupo 7255",
    transform: "translate(1.082 8.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2448",
    "data-name": "Trazado 2448",
    d: "M1496.676,2367.62c-3.838,1.614-9.777,1.276-13.826.767a4.487,4.487,0,0,1-3.776-5.146h0a4.393,4.393,0,0,1,4.5-3.853c3.787.184,9.468.271,13.066-.558",
    transform: "translate(-1479.027 -2358.83)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7256",
    "data-name": "Grupo 7256",
    transform: "translate(1.082 11.66)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2449",
    "data-name": "Trazado 2449",
    d: "M1496.669,2411.547c-3.838,1.614-9.78,1.278-13.828.768a4.488,4.488,0,0,1-3.776-5.146,4.549,4.549,0,0,1,.478-1.488,4.335,4.335,0,0,0,3.3,2.334c4.043.508,9.973.846,13.811-.762Z",
    transform: "translate(-1479.018 -2405.68)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7257",
    "data-name": "Grupo 7257",
    transform: "translate(0 7.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2450",
    "data-name": "Trazado 2450",
    d: "M1472.769,2353.365a51.605,51.605,0,0,1-6.33-.428,5.354,5.354,0,0,1-3.606-2.092,5.757,5.757,0,0,1-1.107-4.282,5.459,5.459,0,0,1,5.626-4.782c5.57.271,10.105.082,12.77-.532.541-.125,1.885-.144,2.693,2.36.911,2.823.725,7.342-1.994,8.485A21.524,21.524,0,0,1,1472.769,2353.365Zm-5.677-9.423a3.31,3.31,0,0,0-3.221,2.927,3.529,3.529,0,0,0,.684,2.661,3.2,3.2,0,0,0,2.154,1.257c5.773.726,10.486.48,13.271-.691h0c.541-.228.938-1.016,1.089-2.163a7.634,7.634,0,0,0-.7-4.518c-3.659.786-9.131.725-13.119.531C1467.194,2343.942,1467.143,2343.941,1467.092,2343.941Z",
    transform: "translate(-1461.668 -2341.205)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7258",
    "data-name": "Grupo 7258",
    transform: "translate(13.886 2.949)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2451",
    "data-name": "Trazado 2451",
    d: "M1735.052,2284.787c-3.884.48-9.326.816-13.422-.3v2.066a5.111,5.111,0,0,1-5,5.191H1689.35a5.11,5.11,0,0,1-5-5.191v-15.389a5.11,5.11,0,0,1,5-5.187h27.281a5.04,5.04,0,0,1,4.742,3.545,5.4,5.4,0,0,1,.256,1.642v3.47a71.734,71.734,0,0,0,12.694.314c.047,0,.091,0,.134,0C1734.755,2278.182,1734.964,2281.48,1735.052,2284.787Z",
    transform: "translate(-1684.352 -2265.976)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7259",
    "data-name": "Grupo 7259",
    transform: "translate(48.086 8.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2452",
    "data-name": "Trazado 2452",
    d: "M2232.805,2367.62c3.838,1.614,9.777,1.276,13.826.767a4.487,4.487,0,0,0,3.775-5.146h0a4.393,4.393,0,0,0-4.5-3.853c-3.787.184-9.468.271-13.066-.558",
    transform: "translate(-2232.805 -2358.83)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7260",
    "data-name": "Grupo 7260",
    transform: "translate(48.086 11.663)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2453",
    "data-name": "Trazado 2453",
    d: "M2246.623,2412.359c-4.051.51-9.99.846-13.828-.767l.017-4.286c3.838,1.607,9.765,1.269,13.811.761a4.346,4.346,0,0,0,3.3-2.34,4.648,4.648,0,0,1,.475,1.485A4.488,4.488,0,0,1,2246.623,2412.359Z",
    transform: "translate(-2232.795 -2405.727)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7261",
    "data-name": "Grupo 7261",
    transform: "translate(45.18 7.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2454",
    "data-name": "Trazado 2454",
    d: "M2196.737,2353.367a21.513,21.513,0,0,1-8.052-1.272c-2.719-1.143-2.905-5.662-1.994-8.485.808-2.5,2.153-2.484,2.693-2.36,2.665.614,7.2.8,12.77.532a5.459,5.459,0,0,1,5.626,4.782,5.757,5.757,0,0,1-1.107,4.282,5.353,5.353,0,0,1-3.606,2.092A51.744,51.744,0,0,1,2196.737,2353.367Zm-7.6-9.951a7.635,7.635,0,0,0-.7,4.518c.151,1.147.548,1.935,1.09,2.163h0c2.785,1.171,7.5,1.417,13.271.691a3.2,3.2,0,0,0,2.154-1.257,3.529,3.529,0,0,0,.684-2.661,3.3,3.3,0,0,0-3.375-2.923C2198.272,2344.141,2192.8,2344.2,2189.14,2343.416Z",
    transform: "translate(-2186.199 -2341.207)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7262",
    "data-name": "Grupo 7262",
    transform: "translate(15.443 1.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2455",
    "data-name": "Trazado 2455",
    d: "M1743.447,2240.819v14.086a4.68,4.68,0,0,1-4.574,4.753h-24.979a4.678,4.678,0,0,1-4.574-4.753v-14.086a4.678,4.678,0,0,1,4.574-4.75h24.979a4.613,4.613,0,0,1,4.338,3.247A4.914,4.914,0,0,1,1743.447,2240.819Z",
    transform: "translate(-1709.321 -2236.069)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7263",
    "data-name": "Grupo 7263",
    transform: "translate(15.443 4.331)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2456",
    "data-name": "Trazado 2456",
    d: "M1743.447,2289.649v14.086a4.68,4.68,0,0,1-4.574,4.753h-24.979a4.679,4.679,0,0,1-4.574-4.753v-4.741c4.31,2.477,12.848,6.2,21.416,3.128,4.186-1.5,8.985-6.643,8.985-6.643s.185,5.4.956,5.311c2.143-.237,2.127-11.154,2.533-12.643A4.914,4.914,0,0,1,1743.447,2289.649Z",
    transform: "translate(-1709.321 -2288.146)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7264",
    "data-name": "Grupo 7264",
    transform: "translate(14.358 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2457",
    "data-name": "Trazado 2457",
    d: "M1722.471,2244.447h-24.8a5.751,5.751,0,0,1-5.745-5.745v-14.266a5.751,5.751,0,0,1,5.745-5.745h24.8a5.751,5.751,0,0,1,5.745,5.745V2238.7A5.751,5.751,0,0,1,1722.471,2244.447Zm-24.8-23.588a3.582,3.582,0,0,0-3.577,3.578V2238.7a3.582,3.582,0,0,0,3.577,3.577h24.8a3.582,3.582,0,0,0,3.578-3.577v-14.266a3.582,3.582,0,0,0-3.578-3.578Z",
    transform: "translate(-1691.921 -2218.692)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7265",
    "data-name": "Grupo 7265",
    transform: "translate(37.41 8.781)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_259",
    "data-name": "Elipse 259",
    cx: 3.944,
    cy: 4.096,
    rx: 3.944,
    ry: 4.096,
    fill: "#22a7f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7266",
    "data-name": "Grupo 7266",
    transform: "translate(37.41 8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2458",
    "data-name": "Trazado 2458",
    d: "M2069.487,2363.6a4.2,4.2,0,0,1-.078.813,3.918,3.918,0,0,0-7.735,0,4.222,4.222,0,0,1-.077-.813,3.948,3.948,0,1,1,7.89,0Z",
    transform: "translate(-2061.597 -2359.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7267",
    "data-name": "Grupo 7267",
    transform: "translate(37.41 11.78)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2459",
    "data-name": "Trazado 2459",
    d: "M2069.481,2408.7a3.947,3.947,0,1,1-7.889,0,4.262,4.262,0,0,1,.144-1.1,3.909,3.909,0,0,0,7.6,0A4.262,4.262,0,0,1,2069.481,2408.7Z",
    transform: "translate(-2061.592 -2407.599)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7268",
    "data-name": "Grupo 7268",
    transform: "translate(36.597 7.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2460",
    "data-name": "Trazado 2460",
    d: "M2053.313,2356.294a4.912,4.912,0,1,1,4.757-4.91A4.841,4.841,0,0,1,2053.313,2356.294Zm0-8.193a3.288,3.288,0,1,0,3.131,3.283A3.214,3.214,0,0,0,2053.313,2348.1Z",
    transform: "translate(-2048.556 -2346.475)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7269",
    "data-name": "Grupo 7269",
    transform: "translate(24.097 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2461",
    "data-name": "Trazado 2461",
    d: "M1854.179,2244.447a1.084,1.084,0,0,1-1.084-1.084v-7.209a4.7,4.7,0,0,0-1.764-3.686l-.635-.5a6.879,6.879,0,0,1-2.6-5.393v-6.8a1.084,1.084,0,1,1,2.167,0v6.8a4.7,4.7,0,0,0,1.765,3.686l.634.5a6.88,6.88,0,0,1,2.6,5.394v7.209A1.084,1.084,0,0,1,1854.179,2244.447Z",
    transform: "translate(-1848.1 -2218.692)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7271",
    "data-name": "Grupo 7271",
    transform: "translate(1237.414 678.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2462",
    "data-name": "Trazado 2462",
    d: "M1542.1,2889.113a30.274,30.274,0,0,1-14.362-3.3.78.78,0,0,1,.737-1.374c12.021,6.449,27.7.769,27.859.71a.779.779,0,0,1,.542,1.462A46.555,46.555,0,0,1,1542.1,2889.113Z",
    transform: "translate(-1527.328 -2884.346)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7272",
    "data-name": "Grupo 7272",
    transform: "translate(1265.901 678.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2463",
    "data-name": "Trazado 2463",
    d: "M1999.457,2889.113a46.554,46.554,0,0,1-14.776-2.5.78.78,0,0,1,.542-1.462c.157.058,15.838,5.739,27.859-.71a.78.78,0,0,1,.737,1.374A30.275,30.275,0,0,1,1999.457,2889.113Z",
    transform: "translate(-1984.172 -2884.346)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7273",
    "data-name": "Grupo 7273",
    transform: "translate(1255.688 668.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M1820.389,2721.129a31.379,31.379,0,0,0,22.008,0s-2.961-2.339-11.015-2.339S1820.389,2721.129,1820.389,2721.129Z",
    transform: "translate(-1820.389 -2718.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7274",
    "data-name": "Grupo 7274",
    transform: "translate(1255.688 668.016)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M1820.389,2721.129a31.379,31.379,0,0,0,22.008,0s-2.961-2.339-11.015-2.339S1820.389,2721.129,1820.389,2721.129Z",
    transform: "translate(-1820.389 -2718.79)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7275",
    "data-name": "Grupo 7275",
    transform: "translate(1253.718 669.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2466",
    "data-name": "Trazado 2466",
    d: "M1789.265,2747.96a60.794,60.794,0,0,0,6.334,1.137,57.039,57.039,0,0,0,6.367.442,52.182,52.182,0,0,0,6.38-.375,48.375,48.375,0,0,0,6.324-1.205l.02-.005a.363.363,0,0,1,.273.666,19.178,19.178,0,0,1-3.079,1.372c-.525.2-1.063.353-1.6.512l-.81.226-.819.191a31.651,31.651,0,0,1-6.688.772,30.181,30.181,0,0,1-6.7-.7,25.974,25.974,0,0,1-3.233-.946,17.192,17.192,0,0,1-3.063-1.43.364.364,0,0,1,.274-.665Z",
    transform: "translate(-1788.797 -2747.942)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7276",
    "data-name": "Grupo 7276",
    transform: "translate(1266.576 604.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2467",
    "data-name": "Trazado 2467",
    d: "M2034.626,1743.422c-2.858,3.73-6.136,4.933-9.287,4.486-6.64-.946-12.709-9.244-13.066-16.718-3.289.7-8.517.642-10.785-1.818-3.121-3.384-.406-8-.406-8s-6.085.382-6.085-3.977c0-2.395,9.217-5.746,17.669-5.123a18.6,18.6,0,0,1,8.141,2.633,63.061,63.061,0,0,0-2.162-10.059s-.775.065-2.016.135c-5.053.29-17.818.677-17.26-2.834.7-4.373,18.262-9.276,18.262-9.276.1.13.2.26.3.39,1.639,2.108,3.27,4.384,4.852,6.767C2032.946,1715.338,2041,1735.107,2034.626,1743.422Z",
    transform: "translate(-1994.996 -1692.874)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7277",
    "data-name": "Grupo 7277",
    transform: "translate(1265.494 603.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2468",
    "data-name": "Trazado 2468",
    d: "M2001.634,1687.878a44.79,44.79,0,0,1,7.118,8.733,98.866,98.866,0,0,1,5.554,9.81q1.262,2.523,2.413,5.1c.749,1.729,1.466,3.475,2.1,5.255s1.205,3.59,1.681,5.432a40.717,40.717,0,0,1,1.032,5.646,22.559,22.559,0,0,1-.081,5.849,12.488,12.488,0,0,1-2.267,5.619,13.725,13.725,0,0,1-4.562,3.931,9.6,9.6,0,0,1-6.1.876,11.278,11.278,0,0,1-2.916-.952l-.345-.16-.331-.182c-.219-.124-.441-.244-.657-.372-.415-.279-.847-.538-1.233-.85a19.536,19.536,0,0,1-4.093-4.233,22.38,22.38,0,0,1-2.78-5.149,19.175,19.175,0,0,1-1.257-5.767l1.31,1.008a19.98,19.98,0,0,1-5.247.373,15.43,15.43,0,0,1-2.651-.4,8.971,8.971,0,0,1-2.6-1.056,6.434,6.434,0,0,1-1.177-.932,1.9,1.9,0,0,1-.253-.276l-.231-.287-.229-.289c-.074-.1-.131-.21-.2-.315a6.436,6.436,0,0,1-.361-.651l-.286-.69-.194-.717c-.058-.24-.079-.484-.117-.726a8.5,8.5,0,0,1,.194-2.835,10.708,10.708,0,0,1,.4-1.327c.085-.214.168-.429.266-.64s.191-.407.331-.657l1,1.631c-.252.013-.438.012-.652.009s-.414-.014-.62-.029a10.987,10.987,0,0,1-1.237-.158,7.468,7.468,0,0,1-2.467-.885,4.922,4.922,0,0,1-1.118-.9,4.332,4.332,0,0,1-.8-1.267,4.852,4.852,0,0,1-.321-1.423l-.015-.351v-.044l0-.071.013-.146a2.375,2.375,0,0,1,.045-.285,2.883,2.883,0,0,1,.176-.477,3.049,3.049,0,0,1,.226-.385,4.61,4.61,0,0,1,1.021-1.035,9.315,9.315,0,0,1,1.063-.7,17.2,17.2,0,0,1,2.176-1.027,29.657,29.657,0,0,1,4.478-1.338,34.289,34.289,0,0,1,9.246-.764,20.05,20.05,0,0,1,4.668.854,18.191,18.191,0,0,1,4.408,1.924l-1.772,1.088c-.109-.826-.236-1.651-.368-2.478l-.408-2.49c-.136-.834-.27-1.673-.372-2.525a24.938,24.938,0,0,1-.22-2.6.373.373,0,0,1,.695-.2,17.583,17.583,0,0,1,1.14,2.372,23.19,23.19,0,0,1,.845,2.479c.233.843.437,1.7.6,2.56s.287,1.738.371,2.618l0,.041a1.138,1.138,0,0,1-1.776,1.047,13.843,13.843,0,0,0-3.775-1.769,17.894,17.894,0,0,0-4.17-.765,32.149,32.149,0,0,0-8.652.718,27.568,27.568,0,0,0-4.144,1.236,15.088,15.088,0,0,0-1.895.891,7.219,7.219,0,0,0-.813.537,2.57,2.57,0,0,0-.563.55c-.039.043-.034.068-.06.1s0,.034-.022.049c0,0,.008,0,.006-.007a.009.009,0,0,0,0-.006s0,0,0,0v.027l.01.211a2.693,2.693,0,0,0,.167.766,2.376,2.376,0,0,0,1.025,1.126,7.294,7.294,0,0,0,3.728.762,1.1,1.1,0,0,1,1.137,1.066,1.119,1.119,0,0,1-.135.564c-.061.112-.156.294-.226.455s-.144.337-.212.509a8.47,8.47,0,0,0-.319,1.052,6.34,6.34,0,0,0-.15,2.1c.03.167.039.339.08.5l.129.485.192.459a4.179,4.179,0,0,0,.244.435c.044.071.078.147.13.214l.16.2.158.2.078.1.088.082a4.239,4.239,0,0,0,.77.607,6.842,6.842,0,0,0,1.993.8,13.347,13.347,0,0,0,2.263.34,17.842,17.842,0,0,0,4.652-.329,1.089,1.089,0,0,1,1.309,1v.01a18.855,18.855,0,0,0,3.63,9.751,17.394,17.394,0,0,0,3.637,3.769c.338.275.709.492,1.065.735l.558.315.28.156.289.133a9.113,9.113,0,0,0,2.374.779,7.413,7.413,0,0,0,4.749-.681,11.58,11.58,0,0,0,3.815-3.315,10.342,10.342,0,0,0,1.845-4.641,20.434,20.434,0,0,0,.065-5.285,38.576,38.576,0,0,0-.976-5.332c-.456-1.763-1.009-3.508-1.621-5.235a84.371,84.371,0,0,0-4.432-10.1q-1.272-2.454-2.68-4.836c-.927-1.594-1.9-3.163-2.858-4.736s-1.974-3.115-2.929-4.7-1.938-3.154-2.817-4.822l0,0a.367.367,0,0,1,.571-.442Z",
    transform: "translate(-1977.632 -1687.783)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7278",
    "data-name": "Grupo 7278",
    transform: "translate(1291.252 624.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2469",
    "data-name": "Trazado 2469",
    d: "M2399.807,2039.582a31.778,31.778,0,0,0-1.738-2.709c-.625-.876-1.288-1.72-1.989-2.522a24.323,24.323,0,0,0-2.247-2.223,14.693,14.693,0,0,0-2.523-1.706l-.024-.012a1.085,1.085,0,0,1,1.006-1.923c.025.013.052.029.076.044a16.65,16.65,0,0,1,2.75,2.2,25.959,25.959,0,0,1,2.225,2.594c.671.909,1.289,1.846,1.862,2.807a32.935,32.935,0,0,1,1.574,2.969.542.542,0,0,1-.963.5Z",
    transform: "translate(-2390.704 -2028.363)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7279",
    "data-name": "Grupo 7279",
    transform: "translate(1224.681 604.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2470",
    "data-name": "Trazado 2470",
    d: "M1358.957,1721.375s2.714,4.614-.406,8c-2.268,2.46-7.5,2.522-10.785,1.818-.352,7.393-6.3,15.6-12.858,16.686-3.213.534-6.572-.639-9.5-4.454-6.407-8.358,1.764-28.286,12-43.626,1.631-2.446,3.313-4.773,5-6.922l.005,0,14.06,7.884-13.527,3.668-1.552.42a62.49,62.49,0,0,0-2.162,10.059,18.6,18.6,0,0,1,8.141-2.633c8.453-.623,17.666,2.728,17.666,5.123C1365.039,1721.756,1358.957,1721.375,1358.957,1721.375Z",
    transform: "translate(-1323.144 -1692.874)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7280",
    "data-name": "Grupo 7280",
    transform: "translate(1224.682 629.887)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2471",
    "data-name": "Trazado 2471",
    d: "M1358.967,2110s2.715,4.614-.406,8c-2.267,2.46-7.5,2.522-10.785,1.818-.352,7.393-6.3,15.6-12.858,16.686-3.213.534-6.572-.639-9.5-4.454-2.018-2.633-2.59-6.418-2.105-10.842a11.3,11.3,0,0,0,2.105,5.48c2.923,3.815,6.282,4.988,9.5,4.454,6.559-1.089,10.157-8.8,10.509-16.193,3.289.7,8.4,2.509,10.663.049,3.121-3.384-1.769-7.651-1.769-7.651s7.03,1.314,10.474.084C1363.64,2110.293,1358.967,2110,1358.967,2110Z",
    transform: "translate(-1323.155 -2107.345)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7281",
    "data-name": "Grupo 7281",
    transform: "translate(1266.705 629.887)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2472",
    "data-name": "Trazado 2472",
    d: "M2002.893,2110s-2.715,4.614.406,8c2.267,2.46,7.5,2.522,10.785,1.818.352,7.393,6.3,15.6,12.858,16.686,3.213.534,6.573-.639,9.5-4.454,2.018-2.633,2.59-6.418,2.1-10.842a11.3,11.3,0,0,1-2.1,5.48c-2.923,3.815-6.283,4.988-9.5,4.454-6.559-1.089-10.157-8.8-10.509-16.193-3.289.7-8.4,2.509-10.663.049-3.121-3.384,1.769-7.651,1.769-7.651s-7.03,1.314-10.474.084C1998.219,2110.293,2002.893,2110,2002.893,2110Z",
    transform: "translate(-1997.065 -2107.345)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7282",
    "data-name": "Grupo 7282",
    transform: "translate(1223.607 603.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2473",
    "data-name": "Trazado 2473",
    d: "M1326.536,1688.323c-.879,1.668-1.847,3.246-2.816,4.822s-1.975,3.121-2.93,4.7-1.931,3.142-2.858,4.736q-1.414,2.378-2.68,4.837a84.358,84.358,0,0,0-4.433,10.095c-.612,1.727-1.165,3.472-1.621,5.235a38.594,38.594,0,0,0-.976,5.332,20.445,20.445,0,0,0,.065,5.285,10.339,10.339,0,0,0,1.845,4.641,11.58,11.58,0,0,0,3.815,3.315,7.412,7.412,0,0,0,4.748.681,9.118,9.118,0,0,0,2.374-.778l.289-.133.28-.156.558-.315c.356-.243.727-.46,1.065-.734a17.4,17.4,0,0,0,3.638-3.769,18.856,18.856,0,0,0,3.63-9.752v0a1.089,1.089,0,0,1,1.149-1.025,1.133,1.133,0,0,1,.16.021,17.845,17.845,0,0,0,4.652.329,13.326,13.326,0,0,0,2.263-.34,6.837,6.837,0,0,0,1.993-.8,4.263,4.263,0,0,0,.77-.607l.088-.082.078-.1.158-.2.16-.2c.052-.067.085-.143.13-.214a4.182,4.182,0,0,0,.243-.434l.193-.459.13-.485c.041-.162.05-.335.08-.5a6.342,6.342,0,0,0-.15-2.1,8.486,8.486,0,0,0-.319-1.053c-.068-.171-.134-.344-.212-.509s-.164-.343-.226-.455a1.1,1.1,0,0,1,.438-1.5,1.123,1.123,0,0,1,.564-.135,7.291,7.291,0,0,0,3.728-.762,2.377,2.377,0,0,0,1.025-1.126,2.692,2.692,0,0,0,.167-.766l.01-.212v-.026s0,0,0,0a.012.012,0,0,0,0,.006s.007.01.006.007c-.017-.014,0-.017-.022-.049s-.021-.056-.06-.1a2.572,2.572,0,0,0-.563-.55,7.223,7.223,0,0,0-.813-.537,15.1,15.1,0,0,0-1.894-.891,27.551,27.551,0,0,0-4.144-1.236,32.16,32.16,0,0,0-8.652-.718,17.894,17.894,0,0,0-4.17.765,13.854,13.854,0,0,0-3.775,1.768,1.138,1.138,0,0,1-1.776-1.046l0-.042q.126-1.321.37-2.618c.164-.864.368-1.717.6-2.559a23.257,23.257,0,0,1,.845-2.479,17.659,17.659,0,0,1,1.139-2.372.373.373,0,0,1,.7.2,24.97,24.97,0,0,1-.22,2.6c-.1.852-.236,1.691-.372,2.525l-.408,2.49c-.132.827-.259,1.653-.368,2.478l-1.772-1.088a18.192,18.192,0,0,1,4.408-1.924,20.057,20.057,0,0,1,4.668-.855,34.3,34.3,0,0,1,9.246.765,29.67,29.67,0,0,1,4.478,1.338,17.21,17.21,0,0,1,2.176,1.027,9.367,9.367,0,0,1,1.063.7,4.607,4.607,0,0,1,1.022,1.036,3.009,3.009,0,0,1,.226.385,2.9,2.9,0,0,1,.176.477,2.435,2.435,0,0,1,.045.285l.013.146,0,.071,0,.044-.015.351a4.846,4.846,0,0,1-.321,1.423,4.321,4.321,0,0,1-.8,1.267,4.925,4.925,0,0,1-1.119.9,7.462,7.462,0,0,1-2.467.885,10.922,10.922,0,0,1-1.237.159c-.206.015-.412.024-.619.029s-.4,0-.652-.009l1-1.631c.14.25.232.439.331.657s.181.425.266.64a10.673,10.673,0,0,1,.4,1.327,8.5,8.5,0,0,1,.194,2.835c-.038.242-.059.486-.116.726l-.194.717-.286.69a6.366,6.366,0,0,1-.361.651c-.066.1-.123.217-.2.315l-.229.289-.231.287a1.937,1.937,0,0,1-.253.276,6.44,6.44,0,0,1-1.177.932,8.97,8.97,0,0,1-2.6,1.056,15.442,15.442,0,0,1-2.651.4,19.982,19.982,0,0,1-5.247-.373l1.309-1.008a19.184,19.184,0,0,1-1.257,5.767,22.4,22.4,0,0,1-2.78,5.149,19.547,19.547,0,0,1-4.093,4.233c-.387.312-.819.571-1.234.85-.216.128-.438.248-.657.372l-.331.182-.345.16a11.279,11.279,0,0,1-2.916.952,9.6,9.6,0,0,1-6.1-.876,13.725,13.725,0,0,1-4.562-3.931,12.487,12.487,0,0,1-2.266-5.619,22.569,22.569,0,0,1-.081-5.849,40.722,40.722,0,0,1,1.032-5.646c.476-1.842,1.05-3.65,1.682-5.432s1.354-3.526,2.1-5.255q1.153-2.58,2.412-5.1a98.889,98.889,0,0,1,5.554-9.81,44.786,44.786,0,0,1,7.119-8.733.367.367,0,0,1,.571.441Z",
    transform: "translate(-1305.915 -1687.782)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7283",
    "data-name": "Grupo 7283",
    transform: "translate(1231.778 624.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2474",
    "data-name": "Trazado 2474",
    d: "M1437.005,2039.106a32.714,32.714,0,0,1,1.575-2.969q.858-1.442,1.861-2.807a26.053,26.053,0,0,1,2.225-2.594,16.664,16.664,0,0,1,2.75-2.2,1.085,1.085,0,1,1,1.158,1.835c-.024.015-.049.03-.074.042l-.026.013a14.674,14.674,0,0,0-2.523,1.706,24.273,24.273,0,0,0-2.247,2.222c-.7.8-1.364,1.646-1.989,2.522a31.785,31.785,0,0,0-1.738,2.709l-.008.015a.542.542,0,0,1-.964-.494Z",
    transform: "translate(-1436.956 -2028.365)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7300",
    "data-name": "Grupo 7300",
    transform: "translate(1218.133 531.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7284",
    "data-name": "Grupo 7284",
    transform: "translate(85.99 28.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2475",
    "data-name": "Trazado 2475",
    d: "M2602.347,1013.774h0a.827.827,0,0,1-.86-.8l-1.241-24.449a.843.843,0,0,1,.774-.9h0a8.674,8.674,0,0,1,9.03,8.4l.423,8.337A8.845,8.845,0,0,1,2602.347,1013.774Z",
    transform: "translate(-2600.049 -987.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2476",
    "data-name": "Trazado 2476",
    d: "M2599.373,1011.045a.987.987,0,0,1-.662-.255,1.046,1.046,0,0,1-.346-.732l-1.241-24.449a1.039,1.039,0,0,1,.958-1.1,8.522,8.522,0,0,1,6.22,2.191,9.128,9.128,0,0,1,3.016,6.393l.423,8.337a9.05,9.05,0,0,1-8.309,9.614h0Zm-.786-26.162q-.241,0-.483.014a.648.648,0,0,0-.591.693l1.241,24.449a.658.658,0,0,0,.217.461.589.589,0,0,0,.438.155h0a8.66,8.66,0,0,0,7.943-9.205l-.423-8.337a8.742,8.742,0,0,0-2.887-6.123A8.135,8.135,0,0,0,2598.587,984.883Z",
    transform: "translate(-2597.123 -984.493)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7285",
    "data-name": "Grupo 7285",
    transform: "translate(87.095 41.276)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2477",
    "data-name": "Trazado 2477",
    d: "M2623.955,1193.55l.2,3.91a8.849,8.849,0,0,1-8.127,9.411.829.829,0,0,1-.861-.8l-.332-6.5a.812.812,0,0,0,.77.46l.558-.035A8.7,8.7,0,0,0,2623.955,1193.55Z",
    transform: "translate(-2614.834 -1193.55)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7286",
    "data-name": "Grupo 7286",
    transform: "translate(85.101 27.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2478",
    "data-name": "Trazado 2478",
    d: "M2586,998.567a1.87,1.87,0,0,1-1.254-.482,1.928,1.928,0,0,1-.641-1.349l-1.241-24.449a1.93,1.93,0,0,1,1.792-2.034,9.4,9.4,0,0,1,6.865,2.416,10.012,10.012,0,0,1,3.311,7.01l.423,8.337a9.941,9.941,0,0,1-9.144,10.547h0C2586.079,998.566,2586.041,998.567,2586,998.567Zm-.959-26.16,1.217,23.972a7.784,7.784,0,0,0,6.834-8.252l-.423-8.337a7.859,7.859,0,0,0-2.593-5.505A7.251,7.251,0,0,0,2585.045,972.406Z",
    transform: "translate(-2582.866 -970.237)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7287",
    "data-name": "Grupo 7287",
    transform: "translate(0.889 32.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2479",
    "data-name": "Trazado 2479",
    d: "M1243.649,1061.246h0a.827.827,0,0,1,.861.8l1.241,24.449a.843.843,0,0,1-.775.9h0a8.674,8.674,0,0,1-9.03-8.4l-.423-8.337A8.845,8.845,0,0,1,1243.649,1061.246Z",
    transform: "translate(-1235.316 -1061.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2480",
    "data-name": "Trazado 2480",
    d: "M1241.555,1084.677a8.522,8.522,0,0,1-5.713-2.206,9.128,9.128,0,0,1-3.016-6.393l-.423-8.337a9.05,9.05,0,0,1,8.309-9.614h0a1,1,0,0,1,.721.254,1.044,1.044,0,0,1,.346.732l1.241,24.449a1.039,1.039,0,0,1-.957,1.1Q1241.807,1084.677,1241.555,1084.677Zm-.821-26.161a8.66,8.66,0,0,0-7.943,9.205l.423,8.337a8.74,8.74,0,0,0,2.887,6.122,8.12,8.12,0,0,0,5.937,2.092.649.649,0,0,0,.592-.693l-1.241-24.449a.659.659,0,0,0-.217-.461.6.6,0,0,0-.438-.155Z",
    transform: "translate(-1232.39 -1058.126)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7288",
    "data-name": "Grupo 7288",
    transform: "translate(1.341 47.262)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2481",
    "data-name": "Trazado 2481",
    d: "M1249.286,1293.783l.343,6.783a.845.845,0,0,1-.776.9,8.366,8.366,0,0,1-6.441-2.485,9,9,0,0,1-2.588-5.913l-.178-3.513a8.5,8.5,0,0,0,8.08,4.77l.859-.051A.833.833,0,0,0,1249.286,1293.783Z",
    transform: "translate(-1239.646 -1289.552)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7289",
    "data-name": "Grupo 7289",
    transform: "translate(0 31.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2482",
    "data-name": "Trazado 2482",
    d: "M1228.186,1072.2a9.4,9.4,0,0,1-6.3-2.433,10.009,10.009,0,0,1-3.311-7.01l-.424-8.337a9.941,9.941,0,0,1,9.144-10.546,1.871,1.871,0,0,1,1.366.479,1.928,1.928,0,0,1,.641,1.349l1.241,24.448a1.93,1.93,0,0,1-1.793,2.034Q1228.465,1072.2,1228.186,1072.2Zm-1.04-26.141a7.785,7.785,0,0,0-6.835,8.252l.423,8.337a7.858,7.858,0,0,0,2.593,5.505,7.252,7.252,0,0,0,5.036,1.878Zm.273-.021h0Z",
    transform: "translate(-1218.133 -1043.869)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7290",
    "data-name": "Grupo 7290",
    transform: "translate(20.813 64.702)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2483",
    "data-name": "Trazado 2483",
    d: "M1607.316,1584.1q-1.272,1.247-2.647,2.373a40.127,40.127,0,0,1-3.511,2.579,38.972,38.972,0,0,1-43.726-.555q-1.451-1.008-2.812-2.143-1.418-1.183-2.726-2.49c1.631-2.446,3.313-4.773,5-6.922l.005,0c1.284-4.863,2.213-7.713,2.213-7.713h41.036s.978,3,2.316,8.1C1604.1,1579.435,1605.734,1581.711,1607.316,1584.1Z",
    transform: "translate(-1551.895 -1569.227)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7291",
    "data-name": "Grupo 7291",
    transform: "translate(6.413 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_260",
    "data-name": "Elipse 260",
    cx: 41.734,
    cy: 40.185,
    rx: 41.734,
    ry: 40.185,
    transform: "translate(0 83.35) rotate(-86.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2484",
    "data-name": "Trazado 2484",
    d: "M1392.671,645.727c-.2,0-.39,0-.587,0a39.307,39.307,0,0,1-27.8-12.14,42.249,42.249,0,0,1-11.837-30.381c.408-23.114,18.844-41.647,41.117-41.319a39.307,39.307,0,0,1,27.8,12.141A42.249,42.249,0,0,1,1433.2,604.4l-.195,0,.195,0C1432.8,627.313,1414.67,645.727,1392.671,645.727Zm.3-83.459c-21.789,0-39.74,18.242-40.141,40.941a41.861,41.861,0,0,0,11.728,30.1,38.921,38.921,0,0,0,27.527,12.022c.194,0,.388,0,.582,0,21.789,0,39.74-18.242,40.141-40.941h0a41.861,41.861,0,0,0-11.728-30.1,38.92,38.92,0,0,0-27.527-12.022C1393.364,562.269,1393.169,562.268,1392.976,562.268Z",
    transform: "translate(-1350.477 -559.992)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7292",
    "data-name": "Grupo 7292",
    transform: "translate(8.568 38.626)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2485",
    "data-name": "Trazado 2485",
    d: "M1435.63,1151.065a43.029,43.029,0,0,1,.284,5.782c-.41,23.044-18.729,41.457-40.921,41.129s-39.852-19.281-39.448-42.324c.011-.663.038-1.326.08-1.978,2.351,20.352,18.859,36.239,39.164,36.542C1416.343,1190.534,1434.24,1173.176,1435.63,1151.065Z",
    transform: "translate(-1355.539 -1151.065)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7293",
    "data-name": "Grupo 7293",
    transform: "translate(7.486 0.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2486",
    "data-name": "Trazado 2486",
    d: "M1379.3,633.247c-.2,0-.4,0-.6,0a40.189,40.189,0,0,1-28.426-12.411,43.13,43.13,0,0,1-12.087-31.015c.413-23.394,18.937-42.2,41.419-42.2.2,0,.4,0,.6,0a40.191,40.191,0,0,1,28.427,12.411,43.132,43.132,0,0,1,12.088,31.015C1420.311,614.445,1401.787,633.247,1379.3,633.247Zm.305-83.459c-21.306,0-38.86,17.853-39.252,40.068a40.978,40.978,0,0,0,11.478,29.469,38.038,38.038,0,0,0,26.9,11.751q.284,0,.568,0c21.306,0,38.86-17.853,39.252-40.068h0a40.978,40.978,0,0,0-11.477-29.469,38.038,38.038,0,0,0-26.9-11.751Q1379.893,549.788,1379.61,549.788Z",
    transform: "translate(-1338.183 -547.62)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7294",
    "data-name": "Grupo 7294",
    transform: "translate(8.916 14.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2487",
    "data-name": "Trazado 2487",
    d: "M1440.988,801.8A38.523,38.523,0,0,1,1434,823.824c-3.288,4.705-16.769,12.946-33.385,13.115-15.407.156-29.4-8.361-32.656-13.061a38.272,38.272,0,0,1-6.851-22.014c.067-21.609,17.976-30.582,40.035-30.6S1441.055,780.189,1440.988,801.8Z",
    transform: "translate(-1361.108 -771.264)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7295",
    "data-name": "Grupo 7295",
    transform: "translate(69.515 34.73)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_261",
    "data-name": "Elipse 261",
    cx: 7.382,
    cy: 5.156,
    rx: 7.382,
    ry: 5.156,
    transform: "matrix(0.166, -0.986, 0.986, 0.166, 0, 14.559)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7296",
    "data-name": "Grupo 7296",
    transform: "translate(65.865 53.495)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_262",
    "data-name": "Elipse 262",
    cx: 3.383,
    cy: 2.807,
    rx: 3.383,
    ry: 2.807,
    transform: "translate(0 6.526) rotate(-74.694)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7297",
    "data-name": "Grupo 7297",
    transform: "translate(31.952 25.325)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2488",
    "data-name": "Trazado 2488",
    d: "M1779.679,937.751c4.867,4.833,7.731,11.473,7.705,20.152a38.548,38.548,0,0,1-6.986,22.027c-3.289,4.705-16.771,12.946-33.387,13.116a47.83,47.83,0,0,1-16.469-2.906c20.422-.661,36.845-10.776,40.922-16.612a48.883,48.883,0,0,0,8.867-27.953A43.814,43.814,0,0,0,1779.679,937.751Z",
    transform: "translate(-1730.541 -937.751)",
    fill: "#111a28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7298",
    "data-name": "Grupo 7298",
    transform: "translate(10.899 9.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2489",
    "data-name": "Trazado 2489",
    d: "M1394,707.923a1.082,1.082,0,0,1-.884-1.707c7.094-10.772,20.811-16.956,37.641-16.971h.056c16.686,0,30.339,5.955,37.479,16.347a1.084,1.084,0,0,1-1.574,1.477l-.1-.088-.081-.115c-6.72-9.822-19.74-15.454-35.725-15.454h-.054c-16.1.014-29.167,5.852-35.848,16.02l-.055.076A1.088,1.088,0,0,1,1394,707.923Z",
    transform: "translate(-1392.918 -689.246)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7299",
    "data-name": "Grupo 7299",
    transform: "translate(16.02 20.979)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2490",
    "data-name": "Trazado 2490",
    d: "M1476.86,905.787s-6.38-21.312,4.712-29.816,27.01-8.483,26.635-7.422c0,0-17.637,4.444-24.578,18.916C1478.276,898.624,1476.86,905.787,1476.86,905.787Z",
    transform: "translate(-1475.034 -868.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7301",
    "data-name": "Grupo 7301",
    transform: "translate(1297.57 630.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2491",
    "data-name": "Trazado 2491",
    d: "M2500.857,2125.238a.78.78,0,0,1-.669-.378c-1.907-3.173-7.348-3.4-7.4-3.4a.779.779,0,0,1-.752-.805.77.77,0,0,1,.8-.753c.258.009,6.341.254,8.687,4.156a.78.78,0,0,1-.667,1.181Z",
    transform: "translate(-2492.033 -2119.9)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7302",
    "data-name": "Grupo 7302",
    transform: "translate(1225.886 630.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2492",
    "data-name": "Trazado 2492",
    d: "M1343.247,2125.244a.78.78,0,0,1-.667-1.181c2.346-3.9,8.429-4.147,8.687-4.156a.779.779,0,0,1,.052,1.558c-.087,0-5.5.238-7.4,3.4A.778.778,0,0,1,1343.247,2125.244Z",
    transform: "translate(-1342.468 -2119.906)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6201",
    "data-name": "Grupo 6201",
    transform: "matrix(1, 0.017, -0.017, 1, 843.127, 488.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8128",
    "data-name": "Grupo 8128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3121",
    "data-name": "Trazado 3121",
    d: "M51.93,238.568l-4.463-1.526-1.437,1.867-3.049-1.043L51.4,227.39l3.373,1.154.236,13.435-3.083-1.054Zm.019-2.5.015-4.884L49,235.056Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3122",
    "data-name": "Trazado 3122",
    d: "M67.509,238.066a3.7,3.7,0,0,1-1.83,1.1,5.44,5.44,0,0,1-2.651-.02l-1.862-.415-.988,4.427-3-.67,2.751-12.333,4.867,1.086a5.655,5.655,0,0,1,2.38,1.066,3.579,3.579,0,0,1,1.215,1.747,4.172,4.172,0,0,1,.051,2.169A4.061,4.061,0,0,1,67.509,238.066Zm-2.8-1.483a1.8,1.8,0,0,0,.509-2.283,1.833,1.833,0,0,0-1.192-.691l-1.634-.364-.689,3.092,1.634.364A1.834,1.834,0,0,0,64.705,236.583Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3123",
    "data-name": "Trazado 3123",
    d: "M75.343,245.711l-2.055-5.043-.733-.086L72,245.319l-3.057-.357,1.47-12.551,5.13.6a5.665,5.665,0,0,1,2.469.814,3.6,3.6,0,0,1,1.4,1.6,3.983,3.983,0,0,1,.283,2.073,3.756,3.756,0,0,1-.967,2.151,3.822,3.822,0,0,1-2.247,1.15l2.314,5.31Zm-2.535-7.292,1.9.221a1.744,1.744,0,0,0,1.309-.263,1.565,1.565,0,0,0,.556-1.113,1.516,1.516,0,0,0-.288-1.175,1.75,1.75,0,0,0-1.213-.559l-1.9-.222Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3124",
    "data-name": "Trazado 3124",
    d: "M84.625,236.119l-.052,2.555,4.122.086-.051,2.375-4.12-.085-.057,2.771,4.661.1-.05,2.466-7.74-.16L81.6,233.59l7.738.159-.05,2.466Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3125",
    "data-name": "Trazado 3125",
    d: "M103.136,245.438l-3.067.257-5.78-7.338.65,7.768-3.067.257L90.817,233.79l3.067-.257,5.783,7.373-.653-7.8,3.068-.256Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3126",
    "data-name": "Trazado 3126",
    d: "M111.93,231.713a5.649,5.649,0,0,1,2.714,1.71,7.05,7.05,0,0,1,1.331,6.462,5.631,5.631,0,0,1-1.823,2.654,7.353,7.353,0,0,1-3.252,1.478l-4.637.955-2.55-12.375,4.637-.956A7.348,7.348,0,0,1,111.93,231.713Zm.708,8.253a3.614,3.614,0,0,0,.407-2.841,3.374,3.374,0,0,0-4.358-2.869l-1.429.294,1.483,7.193,1.427-.295A3.712,3.712,0,0,0,112.638,239.966Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3127",
    "data-name": "Trazado 3127",
    d: "M119,228.947l3.566,12.122-2.953.869-3.566-12.123Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3128",
    "data-name": "Trazado 3128",
    d: "M127.435,236.767l5.09-1.909.885,2.36-8.36,3.134-.821-2.19,2.325-9.177-5.055,1.9-.886-2.36,8.36-3.134.821,2.19Z",
    fill: "#fff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_551",
    "data-name": "Rect\\xE1ngulo 551",
    width: 248,
    height: 248,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprendiz);
export default __webpack_public_path__ + "static/media/Aprendiz.a87d36899355e131a87d9b578e42ceea.svg";
export { ForwardRef as ReactComponent };